<div class="container">
  @for (number of numbers; track trackByIndex(idx); let idx = $index) {
    <input
      class="number"
      pplInput
      type="text"
      autocomplete="off"
      [attr.minlength]="1"
      [attr.maxlength]="1"
      [value]="number"
      (input)="onInput($event, idx)"
      (paste)="onPaste($event)"
      (keyup)="onKeyUp($event)" />
  }
</div>
